import {ReactElement} from 'react'
import {Trans} from 'react-i18next'
import Typography from '@material-ui/core/Typography'

import messages from '../../../../../assets/messages'
import {useStyles} from './styles'

/**
 * PT-7908: label and note for a promotional account. The server refuses withdrawals and
 * transfers out of the account until Tauro opens it, so the client reads why on the tile and
 * on the account page.
 */
function PromotionalAccountNote(): ReactElement {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Typography variant="caption" className={classes.label}>
        <Trans {...messages.promotionalAccount} />
      </Typography>
      <Typography variant="caption" component="p" className={classes.note}>
        <Trans {...messages.promotionalAccountNote} />
      </Typography>
    </div>
  )
}

export {PromotionalAccountNote}
